module.exports = __webpack_public_path__ + "static/media/error_icon.c462f0ed.svg";